import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAProductionLog } from "./types";

export const paOTProductionLogListService = (params: {
  page?: number;
  keyword?: string;
  limit?: number;
  startDate?: string;
  endDate?: string;
  empCodes?: string[];
  empIds?: number[];
  transactionType?: string;
  workShiftCodes?: string[];
  machineIds?: string[];
  machineGroupIds?: string[];
  machineGroupCodes?: string[];
  productIds?: string[];
  productCodes?: string[];
  status?: number;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAProductionLog>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paOTProductionLogImportService = (params: {
  startDate: string;
  endDate: string;
  empCodes?: string[];
  workShiftCodes?: string[];
  productCodes?: string[];
  machineCodes?: string[];
  machineGroupCodes?: string[];
  items: {
    date: string;
    workShiftCode: string;
    timeIn: string;
    timeOut: string;
    fromTime: string;
    toTime: string;
    totalHours: number;
    transactionType: string;
    machineGroupCode: string;
    machineCode: string;
    productCode: string;
    productUnit: string;
    empCode: string;
    actualOutputInDayTime: number;
    actualOutputInNightTime: number;
    overOutputInDayTime: number;
    overOutputInNightTime: number;
    overRate: number;
    outputOvertimeInDay: number;
    outputOvertimeInNight: number;
    outputOvertimeInWeekend: number;
    outputOvertimeInWeekendNight: number;
    outputOvertimeInHoliday: number;
    outputOvertimeInHolidayNight: number;
    syncId: null;
  }[];
}) =>
  RestAPIClient.call<PAProductionLog>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paOTProductionLogSyncService = (params: {
  fromDate: string;
  toDate: string;
}) =>
  RestAPIClient.call<PAProductionLog>({
    method: HTTPRequestMethods.POST,
    url: Paths.Sync,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
